module.exports = __webpack_public_path__ + "media/landing_page/landing_page_mobile_bg-77acdd53.png";